/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnMobilePlatform } from './en-mobile-platform';
 /**
 *
 *
 * @export
 * @interface CreateDeviceDto
 */
export interface CreateDeviceDto {

    /**
     * Human-readable name for the device (e.g. \"iPhone\" or \"Pixel 8 Pro\")
     *
     * @type {string}
     * @memberof CreateDeviceDto
     */
    uniqueId: string;

    /**
     * Hardware identifier (e.g. \"iPhone13,3\")
     *
     * @type {string}
     * @memberof CreateDeviceDto
     */
    publicKey: string;

    /**
     * @type {string}
     * @memberof CreateDeviceDto
     */
    name: string;

    /**
     * @type {string}
     * @memberof CreateDeviceDto
     */
    deviceId: string;

    /**
     * OS version (e.g. \"ios\", \"android\")
     *
     * @type {EnMobilePlatform}
     * @memberof CreateDeviceDto
     */
    platform: EnMobilePlatform;

    /**
     * @type {string}
     * @memberof CreateDeviceDto
     */
    systemVersion: string;

    /**
     * @type {string}
     * @memberof CreateDeviceDto
     */
    appVersion: string;

    /**
     * @type {string}
     * @memberof CreateDeviceDto
     */
    manufacturer: string;
}
